import { useEffect, useRef, useState } from 'react';

export default function useInView(options = { root: null, rootMargin: '0px', threshold: 0.12 }) {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(node); // trigger once
      }
    }, options);

    observer.observe(node);
    return () => observer.disconnect();
  }, [ref, options]);

  return [ref, isVisible];
}
